import { Constants, ModalActionTypes, ModalType } from './types'

export function setShowModal(type: ModalType | null, isClose?: boolean): ModalActionTypes {
  document.body.style.overflow = 'hidden'

  return {
    type: Constants.SET_MODAL,
    payload: type,
  }
}

export function setDisableModal(disable: boolean) {
  return {
    type: Constants.SET_DISABLE,
    payload: disable,
  }
}

export function setHideModal(isMultiple?: boolean) {
  return (dispatch: any) => {
    if (isMultiple) {
      return dispatch(setShowMultipleModal(false))
    }

    return dispatch(setShowModal(null, true))
  }
}

export function setShowFormModal(): ModalActionTypes {
  return setShowModal(ModalType.FORM)
}

export function setShowDemoModal(): ModalActionTypes {
  return setShowModal(ModalType.DEMO)
}

export function setShowDeleteModal(): ModalActionTypes {
  return setShowModal(ModalType.DELETE)
}

export function setShowBulkModal(): ModalActionTypes {
  return setShowModal(ModalType.BULK)
}

export function setShowMultipleModal(isMultiple: boolean) {
  return {
    type: Constants.SET_MULTIPLE_MODAL,
    payload: isMultiple,
  }
}
